import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { executeReports } from "../../store/reports/actions";
export var useApiPostExecuteReports = function (trigger, reportBody) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        loadingExecuteReports: state.Reports.loadingExecuteReports,
        responseExecuteReports: state.Reports.responseExecuteReports,
        errorExecuteReports: state.Reports.errorExecuteReports,
    }); }), loadingExecuteReports = _a.loadingExecuteReports, responseExecuteReports = _a.responseExecuteReports, errorExecuteReports = _a.errorExecuteReports;
    useEffect(function () {
        if (trigger) {
            dispatch(executeReports(reportBody));
        }
    }, [trigger, reportBody]);
    return {
        loadingExecuteReports: loadingExecuteReports,
        responseExecuteReports: responseExecuteReports,
        errorExecuteReports: errorExecuteReports,
    };
};
